import { Button, Card, Group, LoadingOverlay, Select, Stack, Text, TextInput } from "@mantine/core";
import { useForm } from "@mantine/form";
import { showNotification } from "@mantine/notifications";
import React from "react";
import { useMutation, useQueryClient } from "react-query";
import BackendServiceV2 from "services/v2/BackendService";
import { Check, X } from "tabler-icons-react";

export function EntityMetadataCreate({categories}) {

    const queryClient = useQueryClient();

    const form = useForm({
        initialValues: {
            slug: '',
            displayName: '',
            type: '',
            idEntityCategory: ''
        },
    
        validate: {
            slug: (value) => (/^[a-z-]+$/.test(value) ? null : 'Caracteres inválidos'),
        },
    });

    const {mutate: createCategory, isLoading} = useMutation(values => {
        return BackendServiceV2.post('/entity/metadata', values);
    }, {
        onSuccess: () => {
            queryClient.invalidateQueries('entity-metadata-list');
            form.reset();
            showNotification({
                title: 'Metadata criada com sucesso!',
                message: '',
                autoClose: 5000,
                color: 'green',
                icon: <Check />
            });
        },
        onError: (error) => {
            showNotification({
                title: 'Um erro ocorreu',
                message: error?.response?.data?.message,
                autoClose: 5000,
                color: 'red',
                icon: <X />
            });
        }
    })

    return (<>
        <LoadingOverlay visible={isLoading} />

        <form onSubmit={form.onSubmit(values => {createCategory(values)})} style={{width: '100%'}}>
            <Stack>
                <Group grow>
                    <TextInput
                        required
                        label="Slug"
                        description="Apenas minúsculas e -"
                        {...form.getInputProps('slug')}
                    />

                    <TextInput
                        required
                        label="Nome de exibição"
                        description="Nome exibido na interface para os usuários"
                        {...form.getInputProps('displayName')}
                    />
                </Group>

                <Group grow>
                    <Select
                        required
                        size="sm"
                        label="Tipo"
                        data={[
                            {value: 'BOOLEAN', label: 'Booleano'},
                            {value: 'NUMBER', label: 'Número'},
                            {value: 'STRING', label: 'Texto'},
                        ]}
                        {...form.getInputProps('type')}
                    />

                    <Select
                        required
                        size="sm"
                        label="Categoria"
                        data={categories.map(category => {
                            return {
                                label: category.displayName, 
                                value: category.id
                            }
                        })}
                        {...form.getInputProps('idEntityCategory')}
                    />
                </Group>

                <Button type="submit">Criar</Button>
            </Stack>
        </form>

        <Stack style={{width: '100%'}}>
            {categories.map(category => (
                <div key={category.id}>
                    <Text weight="bold">{category.displayName} ({category.slug})</Text>

                    <Stack>
                        {category.metadatas.map(metadata => (
                            <Card key={metadata.id} withBorder p={10}>
                                <Text size="sm">{metadata.displayName} ({metadata.slug}) - {metadata.type}</Text>
                            </Card>
                        ))}
                    </Stack>
                </div>
            ))}
        </Stack>
    </>)
}